export const PRODUCT_DATABASE_SEARCHED = 'Product Database Searched'
